// components/ErrorBoundary.js
import React, { Component } from "react";
import Router from "next/router";
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    // Log the error to an error reporting service if needed
    console.error("Uncaught error:", error, errorInfo);
    // Redirect to the home page on error
    setTimeout(() => {
      window.location.href = "/";
    }, 3000); // Redire
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="errorContainer">
          <div className="errorMessage">
          <img
              className="icon"
              src="/img/general/404.svg"
              alt="Inconvenience"
              style={{
                width: '50%',
                margin: 'auto'
              }}
            />
            <h1>Sorry for Inconvenience</h1>
            <p>Redirecting to home...</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;